// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-discount-container .listing-header {
  display: flex;
  place-content: center;
  align-items: center;
  padding: 0.0625rem 0 1.875rem 0;
}
.add-discount-container .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.add-discount-container {
  overflow: auto;
  padding: 1.5rem 1.875rem 1.5rem 1.875rem;
}
.add-discount-container .heading-label {
  font: normal normal bold 1.125rem/27px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-container .form-container .form-inputs {
  padding-bottom: 0.75rem;
}
.add-discount-container .form-container .form-inputs ion-item .country-code {
  display: none;
}
.add-discount-container .form-container .form-inputs ion-item.item-has-value .country-code,
.add-discount-container .form-container .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.add-discount-container .form-container .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}

ion-select {
  width: 100%;
  font: normal normal 600 1rem/24px Noto Sans;
}

.company-address-div {
  width: 49.2%;
}

.company-address-class {
  display: flex;
  place-content: space-between;
}

ion-input,
ion-item {
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 1rem;
  line-height: 1.3125rem;
}

ion-list {
  padding: 0;
}

.text-left {
  right: 0 !important;
  left: unset !important;
}

.text-right {
  left: 0 !important;
  right: unset !important;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.arabic-label {
  direction: ltr !important;
  text-align: right !important;
}

.arabic-select::part(placeholder) {
  direction: ltr;
  text-align: right;
}

.date-div {
  align-items: center;
}

.add-discount-div .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.add-discount-div .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.add-discount-div .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
  width: 100%;
}
.add-discount-div .listing-table .table {
  width: 100%;
}
.add-discount-div .listing-table .table .column-heading {
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 0.975rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
}
.add-discount-div .listing-table .table .img-col {
  width: 90px;
}
.add-discount-div .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.add-discount-div .listing-table .table .product-id {
  font: normal normal bold 1rem/24px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body {
  font: normal normal normal 1rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.add-discount-div .listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.add-discount-div .listing-table .table .table-body .table-row td .product-image {
  width: 5rem;
  height: 5rem;
  max-width: 5rem;
  max-height: 5rem;
}
.add-discount-div .listing-table .table .table-body .table-row td .product-image img {
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}
.add-discount-div .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.name-col {
  width: 135px;
}

.subclass-col {
  width: 100px;
}

.qty-sold-col {
  min-width: 80px;
}

.price-col {
  min-width: 60px;
}

.sku-col {
  min-width: 100px;
}

.uploaded-time-col {
  min-width: 120px;
}

.edit-col {
  min-width: 60px;
}

.edit-img-icon {
  cursor: pointer;
}

.search-icon {
  align-self: center;
  margin: 0.25rem 2.625rem 0 0;
  cursor: pointer;
}

.product-checkbox {
  --opacity: 1;
  --border-color: var(--ion-color-primary-border);
  --border-width: 1px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font: normal normal bold 0.75rem/14px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

th {
  padding: 0.9375rem 0 1.25rem 0;
}

ion-select::part(icon) {
  opacity: 1;
  margin-left: 1rem;
  color: transparent;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.add-discount-div {
  padding: 0 0.3125rem 0 0;
}

.profile-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.profile-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.profile-bottom-container .cancel:hover {
  font-weight: 600;
}
.profile-bottom-container .profile-button {
  position: relative;
}
.profile-bottom-container .profile-button ion-button {
  --background: var(--ion-color-primary);
  width: 130px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.close-div {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  top: 0.3125rem;
}
.close-div .close-icon {
  cursor: pointer;
  max-width: 40px;
}

::-webkit-scrollbar {
  width: 0.625rem;
}

p.file-name {
  margin: 0;
  margin-top: 0.5rem;
  font-weight: 500;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.country-code {
  display: none;
}

.hidden-input {
  visibility: hidden;
}

.file-input {
  opacity: 0;
  display: none;
}

ion-item {
  height: 5cm;
}

ng-select {
  height: 50px !important;
}

.upload-btn,
.remove-btn {
  margin-top: auto;
  margin-bottom: auto;
  --background: var(--ion-color-primary);
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  height: 38px;
  width: 90px;
  --border-radius: 0;
  --box-shadow: none;
}

.remove-btn {
  --background: var(--ion-color-primary-white) !important;
  box-shadow: none;
  color: var(--ion-color-secondary-black);
}

.preview-image {
  height: 100%;
  width: 100%;
  max-width: 116px;
  max-height: 49px;
  object-fit: contain;
  margin: 0.3125rem 0.9375rem 0.3125rem 0 !important;
}

ion-item.item-has-value .country-code,
ion-item.item-has-focus .country-code {
  display: flex;
}

ion-label {
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}

.spinner-btn {
  color: var(--ion-color-primary-white);
  position: absolute;
  right: 81px;
  top: 0.625rem;
}

.arabic-class {
  direction: rtl !important;
}
.arabic-class ion-label {
  -webkit-transform-origin-x: right;
}

.trash-icon {
  cursor: pointer;
}

.more-info-tooltip {
  position: absolute;
  right: -25px;
  top: 28%;
  z-index: 99999999;
}
.more-info-tooltip img {
  cursor: pointer;
}

.more-info-tooltip .more-info-tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 0.3125rem 0.5rem;
  top: 1.75rem;
  right: 25%;
  left: unset;
  font-size: 0.875rem;
  width: 22em;
  position: absolute;
  z-index: 100000000000000000;
  white-space: nowrap;
}

.more-info-file-tooltip {
  width: 20em !important;
}

.more-info-tooltip:hover .more-info-tooltiptext {
  visibility: visible;
}

.discount-logo {
  position: relative;
}

.info-rtl {
  left: -25px;
  right: unset !important;
}
.info-rtl .more-info-tooltiptext {
  right: unset !important;
  left: 0 !important;
}

.info-icon {
  margin-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-discount/add-discount.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;AAAF;AAEE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAAH;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,2BAAA;AAFD;;AAKA;EACC,cAAA;EACA,wCAAA;AAFD;AAIC;EACC,gDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAFF;AAME;EACC,uBAAA;AAJH;AAOI;EACC,aAAA;AALL;AAWI;;EACC,aAAA;AARL;AAYG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AAVJ;;AAgBA;EACC,WAAA;EACA,2CAAA;AAbD;;AAgBA;EACC,YAAA;AAbD;;AAgBA;EACC,aAAA;EACA,4BAAA;AAbD;;AAgBA;;EAEC,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;AAbD;;AAgBA;EACC,UAAA;AAbD;;AAgBA;EACC,mBAAA;EACA,sBAAA;AAbD;;AAgBA;EACC,kBAAA;EACA,uBAAA;AAbD;;AAgBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AAbD;;AAgBA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AAbD;;AAgBA;EACC,yBAAA;EACA,4BAAA;AAbD;;AAgBA;EACC,cAAA;EACA,iBAAA;AAbD;;AAgBA;EACC,mBAAA;AAbD;;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAdF;AAgBE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAdH;AAkBC;EACC,oBAAA;EACA,gBAAA;EACA,WAAA;AAhBF;AAkBE;EACC,WAAA;AAhBH;AAkBG;EACC,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;AAhBJ;AAoBG;EACC,WAAA;AAlBJ;AAqBG;EACC,gBAAA;EACA,gBAAA;AAnBJ;AAsBG;EACC,4CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AApBJ;AAuBG;EACC,8CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AArBJ;AAuBI;EACC,wDAAA;AArBL;AAuBK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AArBN;AAuBM;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AArBP;AAuBO;EACC,YAAA;EACA,WAAA;EACA,eAAA;EAEA,gBAAA;AAtBR;AA2BK;EACC,aAAA;EACA,mBAAA;AAzBN;;AAkCA;EACC,yBAAA;AA/BD;;AAkCA;EACC,2BAAA;AA/BD;;AAmCA;EACC,YAAA;AAhCD;;AAmCA;EACC,YAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AAhCD;;AAmCA;EACC,YAAA;EACA,+CAAA;EACA,mBAAA;AAhCD;;AAmCA;EACC,wDAAA;EACA,+CAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AAhCD;;AAmCA;EACC,8BAAA;AAhCD;;AAmCA;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,wEAAA;AAhCD;;AAmCA;EAGC,wBAAA;AAlCD;;AAqCA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AAlCD;AAoCC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAlCF;AAoCE;EACC,gBAAA;AAlCH;AAsCC;EACC,kBAAA;AApCF;AAsCE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AApCH;;AAyCA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAtCD;AAwCC;EACC,eAAA;EACA,eAAA;AAtCF;;AA2CA;EACC,eAAA;AAxCD;;AA4CA;EACC,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;AAzCD;;AA4CA;EACC,aAAA;AAzCD;;AA6CA;EACC,kBAAA;AA1CD;;AA6CA;EACC,UAAA;EACA,aAAA;AA1CD;;AA6CA;EACC,WAAA;AA1CD;;AA6CA;EACC,uBAAA;AA1CD;;AA6CA;;EAEC,gBAAA;EACA,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AA1CD;;AA6CA;EACC,uDAAA;EACA,gBAAA;EACA,uCAAA;AA1CD;;AA6CA;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;AA1CD;;AA+CC;;EACC,aAAA;AA3CF;;AAgDA;EACC,yBAAA;EACA,uCAAA;AA7CD;;AAgDA;EACC,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA7CD;;AAgDA;EACC,yBAAA;AA7CD;AA+CC;EACC,iCAAA;AA7CF;;AAiDA;EACC,eAAA;AA9CD;;AAiDA;EACC,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;AA9CD;AAgDC;EACC,eAAA;AA9CF;;AAkDA;EACC,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AA/CD;;AAkDA;EACC,sBAAA;AA/CD;;AAkDA;EACC,mBAAA;AA/CD;;AAkDA;EACC,kBAAA;AA/CD;;AAkDA;EACC,WAAA;EACA,uBAAA;AA/CD;AAiDC;EACC,uBAAA;EACA,kBAAA;AA/CF;;AAmDA;EACC,0BAAA;AAhDD","sourcesContent":[".add-discount-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tplace-content: center;\n\t\talign-items: center;\n\t\tpadding: 0.0625rem 0 1.875rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.add-discount-container {\n\toverflow: auto;\n\tpadding: 1.5rem 1.875rem 1.5rem 1.875rem;\n\n\t.heading-label {\n\t\tfont: normal normal bold 1.125rem /27px Noto Sans;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n\n\t.form-container {\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-select {\n\twidth: 100%;\n\tfont: normal normal 600 1rem /24px Noto Sans;\n}\n\n.company-address-div {\n\twidth: 49.2%;\n}\n\n.company-address-class {\n\tdisplay: flex;\n\tplace-content: space-between;\n}\n\nion-input,\nion-item {\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 1rem;\n\tline-height: 1.3125rem;\n}\n\nion-list {\n\tpadding: 0;\n}\n\n.text-left {\n\tright: 0 !important;\n\tleft: unset !important;\n}\n\n.text-right {\n\tleft: 0 !important;\n\tright: unset !important;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.arabic-label {\n\tdirection: ltr !important;\n\ttext-align: right !important;\n}\n\n.arabic-select::part(placeholder) {\n\tdirection: ltr;\n\ttext-align: right;\n}\n\n.date-div {\n\talign-items: center;\n}\n\n.add-discount-div {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\t\twidth: 100%;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 0.975rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t\t}\n\n\n\t\t\t.img-col {\n\t\t\t\twidth: 90px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.product-id {\n\t\t\t\tfont: normal normal bold 1rem /24px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\tfont: normal normal normal 1rem /21px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\n\t\t\t\t\t\t.product-image {\n\t\t\t\t\t\t\twidth: 5rem;\n\t\t\t\t\t\t\theight: 5rem;\n\t\t\t\t\t\t\tmax-width: 5rem;\n\t\t\t\t\t\t\tmax-height: 5rem;\n\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\t\t\t;\n\t\t\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n\n.name-col {\n\twidth: 135px;\n}\n\n.subclass-col {\n\twidth: 100px;\n}\n\n.qty-sold-col {\n\tmin-width: 80px;\n}\n\n.price-col {\n\tmin-width: 60px;\n}\n\n.sku-col {\n\tmin-width: 100px;\n}\n\n.uploaded-time-col {\n\tmin-width: 120px;\n}\n\n.edit-col {\n\tmin-width: 60px;\n}\n\n.edit-img-icon {\n\tcursor: pointer;\n}\n\n.search-icon {\n\talign-self: center;\n\tmargin: 0.25rem 2.625rem 0 0;\n\tcursor: pointer;\n}\n\n.product-checkbox {\n\t--opacity: 1;\n\t--border-color: var(--ion-color-primary-border);\n\t--border-width: 1px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont: normal normal bold 0.75rem /14px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\nth {\n\tpadding: 0.9375rem 0 1.25rem 0;\n}\n\nion-select::part(icon) {\n\topacity: 1;\n\tmargin-left: 1rem;\n\tcolor: transparent;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.add-discount-div {\n\t// overflow: auto;\n\t// max-height: 70%;\n\tpadding: 0 0.3125rem 0 0;\n}\n\n.profile-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.profile-button {\n\t\tposition: relative;\n\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 130px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.close-div {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tposition: absolute;\n\twidth: 100%;\n\ttop: 0.3125rem;\n\n\t.close-icon {\n\t\tcursor: pointer;\n\t\tmax-width: 40px;\n\t}\n\n}\n\n::-webkit-scrollbar {\n\twidth: 0.625rem;\n}\n\n\np.file-name {\n\tmargin: 0;\n\tmargin-top: 0.5rem;\n\tfont-weight: 500;\n\twidth: 100%;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tdisplay: -webkit-box !important;\n\t-webkit-line-clamp: 1;\n\t-webkit-box-orient: vertical;\n}\n\n.country-code {\n\tdisplay: none;\n\n}\n\n.hidden-input {\n\tvisibility: hidden;\n}\n\n.file-input {\n\topacity: 0;\n\tdisplay: none;\n}\n\nion-item {\n\theight: 5cm;\n}\n\nng-select {\n\theight: 50px !important;\n}\n\n.upload-btn,\n.remove-btn {\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n\t--background: var(--ion-color-primary);\n\tfont-weight: 600;\n\tfont-size: 0.9375rem;\n\tline-height: 1.125rem;\n\tletter-spacing: 0.4px;\n\theight: 38px;\n\twidth: 90px;\n\t--border-radius: 0;\n\t--box-shadow: none;\n}\n\n.remove-btn {\n\t--background: var(--ion-color-primary-white) !important;\n\tbox-shadow: none;\n\tcolor: var(--ion-color-secondary-black);\n}\n\n.preview-image {\n\theight: 100%;\n\twidth: 100%;\n\tmax-width: 116px;\n\tmax-height: 49px;\n\tobject-fit: contain;\n\tmargin: 0.3125rem 0.9375rem 0.3125rem 0 !important;\n}\n\nion-item.item-has-value,\nion-item.item-has-focus {\n\t.country-code {\n\t\tdisplay: flex;\n\n\t}\n}\n\nion-label {\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary-black);\n}\n\n.spinner-btn {\n\tcolor: var(--ion-color-primary-white);\n\tposition: absolute;\n\tright: 81px;\n\ttop: 0.625rem;\n}\n\n.arabic-class {\n\tdirection: rtl !important;\n\n\tion-label {\n\t\t-webkit-transform-origin-x: right;\n\t}\n}\n\n.trash-icon {\n\tcursor: pointer;\n}\n\n.more-info-tooltip {\n\tposition: absolute;\n\tright: -25px;\n\ttop: 28%;\n\tz-index: 99999999;\n\n\timg {\n\t\tcursor: pointer;\n\t}\n}\n\n.more-info-tooltip .more-info-tooltiptext {\n\tvisibility: hidden;\n\tbackground-color: black;\n\tcolor: #fff;\n\ttext-align: center;\n\tborder-radius: 6px;\n\tpadding: 0.3125rem 0.5rem;\n\ttop: 1.75rem;\n\tright: 25%;\n\tleft: unset;\n\tfont-size: 0.875rem;\n\twidth: 22em;\n\tposition: absolute;\n\tz-index: 99999999999999999;\n\twhite-space: nowrap;\n}\n\n.more-info-file-tooltip {\n\twidth: 20em !important;\n}\n\n.more-info-tooltip:hover .more-info-tooltiptext {\n\tvisibility: visible;\n}\n\n.discount-logo {\n\tposition: relative;\n}\n\n.info-rtl {\n\tleft: -25px;\n\tright: unset !important;\n\n\t.more-info-tooltiptext {\n\t\tright: unset !important;\n\t\tleft: 0 !important;\n\t}\n}\n\n.info-icon {\n\tmargin-right: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
